import dayjs from 'dayjs'
import 'dayjs/locale/tr'
import i18n from '@/i18n'

/**
 * Uygulamanın O ANKİ dilinden türetilen biçim etiketleri. Tarih/sayı biçimi, sıralama, grafik ve
 * dayjs dili buradan okunur — sabit 'tr-TR' İngilizce arayüzde "1 Eki 2026" / "1.234,5" gösteriyordu.
 * Fonksiyon (sabit değil): dil çalışma anında değişir; template/computed içinden çağrıldığında
 * i18n.global.locale reaktif okunduğu için dil değişince yeniden hesaplanır.
 */
const BCP47: Record<string, string> = {
    tr: 'tr-TR',
    en: 'en-US',
    de: 'de-DE',
    es: 'es-ES',
    fr: 'fr-FR'
}

/** Kısa dil kodu ("tr", "en"). */
export function appLang(): string {
    const raw = i18n.global.locale as unknown
    const value = typeof raw === 'string' ? raw : (raw as { value?: string })?.value
    return String(value || 'tr').toLowerCase().split('-')[0] || 'tr'
}

/** Intl / toLocale*String için BCP-47 etiketi ("tr-TR", "en-US"). */
export function appLocale(): string {
    return BCP47[appLang()] ?? 'tr-TR'
}

/**
 * dayjs genel dilini uygulama diline eşitler ("2 saat önce" / "2 hours ago", ay adları).
 * Eskiden bileşenler modül yüklenirken dayjs.locale('tr') çağırıp dili kalıcı Türkçeye çekiyordu.
 */
export function syncDayjsLocale(lang: string = appLang()): void {
    dayjs.locale(lang === 'tr' ? 'tr' : 'en')
}

/** Para biriminin dile uygun kısa simgesi ("₺", "$", "AED"). Geçersiz kodda kodun kendisi. */
export function currencySymbol(code: string): string {
    try {
        const part = new Intl.NumberFormat(appLocale(), { style: 'currency', currency: code, currencyDisplay: 'narrowSymbol' })
            .formatToParts(0).find((p) => p.type === 'currency')
        return part?.value || code
    } catch {
        return code
    }
}

/** Kısa saat/dakika birimleri (i18n): en "h"/"min", tr "sa"/"dk". */
export function unitHour(): string { return i18n.global.t('common.unit.hourShort') }
export function unitMinute(): string { return i18n.global.t('common.unit.minuteShort') }
/** Dakikayı "2 h 25 min" / "2 sa 25 dk" biçiminde yazar. */
export function durationLabel(totalMinutes: number): string {
    const min = Math.max(0, Math.round(totalMinutes))
    const h = Math.floor(min / 60)
    const m = min % 60
    return h > 0 ? `${h} ${unitHour()} ${m} ${unitMinute()}` : `${m} ${unitMinute()}`
}
